// Food Habits slug options
export const QUIZ_SLUG_PREFERENCE = {
  ALL_PREFERENCES: 'all-preferences',
  NO_DIARY: 'no-dairy',
  NO_GLUTEN: 'no-gluten',
  NO_MEAT: 'no-meat',
  NO_MEAT_NO_GLUTEN: 'no-meat-no-gluten',
  NO_PREFERENCES: 'no-preferences',
};
